import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useUser from 'hooks/useUser';

import LoginForm from './components/LoginForm';

const LoginRegister = () => {
  const navigate = useNavigate();
  const user = useUser();
  useEffect(() => {
    if (user) {
      const navigateUrl = user?.role === 'ADMIN' ? '/admin-dashboard' : '/dashboard-overview';
      navigate(navigateUrl);
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-background to-secondary-50 flex items-center justify-center px-4 py-8">
      {/* Main Authentication Container */}
      <div className="w-full max-w-6xl">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center space-x-3 mb-4">
            <img
              src="/assets/images/qodors-desktop.png"
              alt="Qodors — Employee Management System"
              className="h-24 object-contain"
            />
          </div>
          <p className="text-text-secondary text-lg">Single Space for all your work!</p>
        </div>

        {/* Authentication Card */}
        <div className="bg-surface rounded-2xl shadow-xl border border-border overflow-hidden max-w-lg mx-auto">
          <div className="p-8">
            <div className="mb-8">
              <h2 className="text-2xl font-semibold text-text-primary mb-2">Welcome back!</h2>
              <p className="text-text-secondary">Enter your credentials to access your workspace</p>
            </div>

            {/* Login Form */}
            <LoginForm />
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-8 text-sm text-text-secondary">
          <p>
            By continuing, you agree to our{' '}
            <button className="text-primary hover:text-primary-700 transition-colors duration-200">
              Terms of Service
            </button>{' '}
            and{' '}
            <button className="text-primary hover:text-primary-700 transition-colors duration-200">
              Privacy Policy
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginRegister;
